import { configureStore } from '@reduxjs/toolkit';
import appSettingReducer from './AppSettingSlice';

const appSettingStore = configureStore({
  reducer: {
    appSetting: appSettingReducer
  },
});

export default appSettingStore;